import { BASE_FONT_SIZE } from '../constants';

export const capitalize = (s: string) => {
  if (typeof s !== 'string') return '';
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const convertPxToRem = (pixels: number) => `${pixels / BASE_FONT_SIZE}rem`;
